import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpUtils } from "../shared/http.utils";
import { EventFilters } from "../model/filters/event-filters";

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  private readonly eventsURL: string;

  constructor(private http: HttpClient) {
    this.eventsURL = "/catalog/events";
  }

  public getEvents(offset?: number, limit?: number, filters?: EventFilters): Observable<any>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new EventFilters();
    return this.http.post<any>(this.eventsURL, body, options);
  }

  public searchEvents(tenantUuid: string, deviceUuid: string, sensorUuid: string, triggerName: string, from: number, until: number) {
    let url = `${this.eventsURL}/${tenantUuid}/${deviceUuid}/${sensorUuid}/${triggerName}/${from}/${until}`;
    return this.http.get<any>(url);
  }
  
}
